import { BaseListStore } from '@monorepo/controlled/src/stores/base-list.store';
import { DestinationsApi } from '../../apis/destinations.api';
import { DestinationModel } from '../../models/destination.model';
import { DestinationCrudStore } from './destination-crud.store';

export class DestinationStore {
	crud = new DestinationCrudStore();

	listStore = new BaseListStore<DestinationModel>({
		listFunc: DestinationsApi.list,
		model: DestinationModel,
	});

	getCrud() {
		return this.crud;
	}
}
